import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const AgbPage = () => {
  return (
    <div className="min-h-screen">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/register" className="inline-flex items-center gap-1 text-sm text-emerald-600 hover:text-emerald-700 mb-8 dark:text-emerald-400">
          <ArrowLeft size={16} /> Zurück zur Registrierung
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-2 dark:text-gray-100">Allgemeine Geschäftsbedingungen</h1>
        <p className="text-sm text-gray-500 mb-8 dark:text-gray-400">Stand: Juni 2026 | PredFuture</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700 text-[15px] leading-relaxed dark:text-gray-300">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">§ 1 Geltungsbereich</h2>
            <p>
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der Plattform PredFuture
              (nachfolgend „Plattform"), betrieben von der hobeco UG (haftungsbeschränkt), Köln, eingetragen im
              Handelsregister des Amtsgerichts Köln, HRB 127985.
            </p>
            <p>
              Mit der Registrierung auf der Plattform akzeptiert der Nutzer diese AGB in ihrer jeweils gültigen Fassung.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">§ 2 Leistungsbeschreibung</h2>
            <p>
              PredFuture ist eine Prognoseplattform, auf der Nutzer mit virtuellen Credits auf den Ausgang
              zukünftiger Ereignisse wetten können. Die Plattform dient ausschließlich Unterhaltungszwecken.
              Es handelt sich nicht um Glücksspiel im Sinne des Glücksspielstaatsvertrags, da ausschließlich
              virtuelle Währung verwendet wird, die keinen realen Geldwert besitzt.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">§ 3 Registrierung und Nutzerkonto</h2>
            <p>
              Die Nutzung der Plattform erfordert eine Registrierung. Der Nutzer muss mindestens 18 Jahre alt sein.
              Jeder Nutzer darf nur ein Konto anlegen. Der gewählte Benutzername darf keine Rechte Dritter verletzen
              und keine anstößigen oder irreführenden Inhalte enthalten.
            </p>
            <p>
              Der Nutzer ist für die Geheimhaltung seiner Zugangsdaten selbst verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">§ 4 Virtuelle Credits</h2>
            <p>
              Virtuelle Credits sind eine plattforminterne Währung ohne realen Geldwert. Ein Umtausch in
              echtes Geld oder eine Auszahlung ist nicht möglich. Credits können durch Aktivität auf der
              Plattform verdient oder über die Plattform erworben werden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">§ 5 Wetten und Abrechnungen</h2>
            <p>
              Wetten werden nach dem Parimutuel-System abgerechnet. Alle Einsätze fließen in einen
              gemeinsamen Pool. Bei Auflösung eines Marktes wird der Pool abzüglich einer Plattformgebühr
              proportional an die Gewinner verteilt.
            </p>
            <p>
              Bei einseitigen Märkten (keine Gegenwetten) werden die Einsätze vollständig zurückerstattet.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">§ 6 Haftungsbeschränkung</h2>
            <p>
              Die Plattform wird „wie besehen" bereitgestellt. PredFuture haftet nicht für die Verfügbarkeit,
              Richtigkeit oder Vollständigkeit der bereitgestellten Inhalte. Eine Haftung für indirekte
              Schäden, entgangenen Gewinn oder Datenverlust ist ausgeschlossen, soweit gesetzlich zulässig.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">§ 7 Kündigung</h2>
            <p>
              Der Nutzer kann sein Konto jederzeit löschen lassen. PredFuture behält sich das Recht vor,
              Nutzerkonten bei Verstoß gegen diese AGB zu sperren oder zu löschen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">§ 8 Änderungen der AGB</h2>
            <p>
              PredFuture behält sich vor, diese AGB jederzeit zu ändern. Änderungen werden dem Nutzer per
              E-Mail oder durch Hinweis auf der Plattform mitgeteilt. Die fortgesetzte Nutzung der Plattform
              gilt als Zustimmung zu den geänderten AGB.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">§ 9 Schlussbestimmungen</h2>
            <p>
              Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist, soweit gesetzlich zulässig,
              der Sitz des Betreibers. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die
              Wirksamkeit der übrigen Bestimmungen unberührt.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-200 text-xs text-gray-400 dark:border-slate-700 dark:text-gray-500">
          <p>hobeco UG (haftungsbeschränkt) | Am Ackerrain 14, 50933 Köln | dev@hobeco.one</p>
        </div>
      </div>
    </div>
  );
};

export default AgbPage;
